import { render, staticRenderFns } from "./VideoLengthErrorWindow.vue?vue&type=template&id=03a2af30&scoped=true"
import script from "./VideoLengthErrorWindow.vue?vue&type=script&lang=js"
export * from "./VideoLengthErrorWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a2af30",
  null
  
)

export default component.exports